// extracted by mini-css-extract-plugin
export default {"main_settings":"MeSettings_main_settings__ajjUN"};